import { FileQuestion, CheckCircle, Package, TrendingUp } from "lucide-react";
import { useDashboardStats } from "@/hooks/useDashboardStats";
import { StatCard } from "@/components/dashboard/StatCard";
import { DashboardScoringWidget } from "@/components/dashboard/DashboardScoringWidget";
import { WelcomeChecklist } from "@/components/dashboard/WelcomeChecklist";

export function DashboardPage() {
  const { data, isLoading, isError } = useDashboardStats();

  return (
    <div>
      <h1 className="text-2xl font-bold">Dashboard</h1>
      <p className="mt-2 text-muted-foreground">
        Deine Kennzahlen im Überblick.
      </p>

      <div className="mt-6">
        <WelcomeChecklist data={data} isLoading={isLoading} />
      </div>

      <div className="mt-6 grid grid-cols-2 lg:grid-cols-4 gap-4">
        <StatCard
          title="Quizzes gesamt"
          value={data?.quizzes.total ?? 0}
          icon={FileQuestion}
          description="Alle erstellten Quizzes"
          isLoading={isLoading}
          isError={isError}
        />
        <StatCard
          title="Publizierte Quizzes"
          value={data?.quizzes.published ?? 0}
          icon={CheckCircle}
          description="Aktuell live"
          isLoading={isLoading}
          isError={isError}
        />
        <StatCard
          title="Produkte im Katalog"
          value={data?.products.total ?? 0}
          icon={Package}
          description="Verfügbare Produkte"
          isLoading={isLoading}
          isError={isError}
        />
        <StatCard
          title="Quiz-Abschlüsse"
          value={data?.completions.total ?? 0}
          icon={TrendingUp}
          description="Abgeschlossene Durchläufe"
          isLoading={isLoading}
          isError={isError}
        />
      </div>

      <div className="mt-6">
        <DashboardScoringWidget />
      </div>
    </div>
  );
}
